import { Observable } from 'rxjs';
import { MXWidget } from '../mx-widget.model';
import { MXUser } from '../mx-user.model';
import { MXWidgetMessageBox } from '@domain/interfaces/mx/mx-widget-message-box.interface';
import { MXBalances } from '../mx-balances.model';
import { MXOffersRewardsMessageBox } from '@domain/interfaces/mx/mx-offers-rewards-message-box.interface';

export abstract class MXGateway {
  abstract validateMXUserAccounts(userId?: number): Observable<MXUser>;
  abstract getMXUser(): Observable<MXUser>;
  abstract setMXUser(mxAccountsConnected: MXUser): void;
  abstract getMXWidget(widgetType: string, mxUserId?: string): Observable<MXWidget>;
  abstract getWidgetMessageBox(): Observable<MXWidgetMessageBox>;
  abstract getMiniWidgetMessageBox(): Observable<MXWidgetMessageBox>;
  abstract getOffersRewardsMessageBox(): Observable<MXOffersRewardsMessageBox>;
  abstract calculateBalances(mxUserId?: string): Observable<MXBalances>;
}
